"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorNode = void 0;
const types_1 = require("./types");
const ErrorNode = () => ({
    id: 'error',
    type: types_1.NodeTypes.ErrorNode,
    version: 1,
    render: () => {
        return 'Invalid Template';
    },
    preview: () => {
        return 'Invalid Template.';
    }
});
exports.ErrorNode = ErrorNode;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3JOb2RlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9ub2Rlcy9lcnJvck5vZGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbUNBQTZDO0FBRXRDLE1BQU0sU0FBUyxHQUFHLEdBQWEsRUFBRSxDQUFDLENBQUM7SUFDeEMsRUFBRSxFQUFFLE9BQU87SUFDWCxJQUFJLEVBQUUsaUJBQVMsQ0FBQyxTQUFTO0lBQ3pCLE9BQU8sRUFBRSxDQUFDO0lBQ1YsTUFBTSxFQUFFLEdBQUcsRUFBRTtRQUNYLE9BQU8sa0JBQWtCLENBQUE7SUFDM0IsQ0FBQztJQUNELE9BQU8sRUFBRSxHQUFHLEVBQUU7UUFDWixPQUFPLG1CQUFtQixDQUFBO0lBQzVCLENBQUM7Q0FDRixDQUFDLENBQUM7QUFWVSxRQUFBLFNBQVMsYUFVbkIifQ==